export const SPOTLIGHT_WIDTH = 300;

export const HOME_SPOTLIGHT_NUMBER = 1;

export const SWITCHER_SPOTLIGHT_NUMBER = 2;

export const ROVO_SPOTLIGHT_NUMBER = 3;

export const FOR_YOU_TARGET = 'for-you';

export const HOME_SWITCHER_TARGET = 'home-switcher';

export const ROVO_CHAT_TARGET = 'rovo-chat';
